import type { ConciseBranch } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'

import { ConfigurationBranchStatus } from '../../branchNameWithStatus/ConfigurationBranchStatus'
import { StandardBranchStatus } from '../../branchNameWithStatus/StandardBranchStatus'
import { WorkspaceName } from '../../workspaceName/WorkspaceName'
import { conciseWorkspaceToWorkspaceKey } from '../branchDetails/branchWorkspaces/helpers'
import type { BranchLeaf } from '../types'
import { getBranchServerFromPath } from './helpers'

type Props = {
  leaf: BranchLeaf
  conciseBranch: Optional<ConciseBranch>
  label?: Optional<string>
}
export const BranchesTreeLeaf = ({ leaf, conciseBranch, label }: Props) => {
  const branchServer = getBranchServerFromPath(leaf.path)
  const isStandardBranch = leaf.isStandardBranch

  if (!leaf.isStandardBranch && !conciseBranch) {
    throw new Error('Cannot render leaf without a concise branch')
  }

  return !leaf.isStandardBranch && leaf.isWorkspace ? (
    <WorkspaceName
      isShowingIcon
      workspaceKey={conciseWorkspaceToWorkspaceKey({
        workspace: leaf.data,
        server: branchServer,
      })}
    />
  ) : (
    <>
      {isStandardBranch ? (
        <StandardBranchStatus server={branchServer} />
      ) : (
        <ConfigurationBranchStatus
          branchKey={{ name: leaf.data.name ?? '', server: branchServer }}
          label={label}
        />
      )}
    </>
  )
}
